import { Component } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-company-owner-edit',
    templateUrl: './breadcrumb.company.owner.edit.component.html'
})

export class BreadcrumbCompanyOwnerEditComponent { }
